module.exports = __webpack_public_path__ + "static/media/backfit.82efc3d7.svg";